exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_AttachmentsContainer_1F6Ru2RwIDknIOJnulyzJR {\n  margin: 45px 40px 20px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.IA_AttachmentsAttachment_2021E8cMeVs233LK22QQF7 {\n  display: flex;\n  align-items: center;\n}\n\n.IA_AttachmentsLink_24XT07z8Mte0HsL39m6ZM5 {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_AttachmentsContainer": "IA_AttachmentsContainer_1F6Ru2RwIDknIOJnulyzJR",
	"IA_AttachmentsAttachment": "IA_AttachmentsAttachment_2021E8cMeVs233LK22QQF7",
	"IA_AttachmentsLink": "IA_AttachmentsLink_24XT07z8Mte0HsL39m6ZM5"
};